import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import CommonButton from './CommonButton';
import { CommonButtonVariants } from '../../constants/CommonButtonVariants';
import RouterPaths from '../../constants/RouterPaths';

const cookieKey = 'cookie-policy';

function CookiesContainer() {
  const [isOpen, setIsOpen] = useState((() => !Cookies.get(cookieKey))());

  return (
    <Modal className="cookies-policy-modal" isOpen={isOpen} centered>
      <ModalHeader className="cookies-policy-modal__header">Cookie Notice</ModalHeader>
      <ModalBody className="cookies-policy-modal__body">
        <p>
          We use only essential cookies on our website. These are required for core functions
          such as security, session management, and access to key services. Since they are
          necessary for the site to work properly, no action is required from you.
        </p>
        <p>
          For more details on how we use cookies and handle data, please see our{' '}
          <Link target="_blank" to={RouterPaths.PRIVACY_POLICY}>
            Privacy Policy
          </Link>
          .
        </p>
      </ModalBody>
      <ModalFooter className="cookies-policy-modal__footer pt-2">
        <CommonButton
          label="Got it"
          handleClick={() => {
            Cookies.set(cookieKey, true);
            setIsOpen(false);
          }}
          variant={CommonButtonVariants.PRIMARY}
        />
      </ModalFooter>
    </Modal>
  );
}
export default CookiesContainer;
